import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { __awaiter, __generator, __read, __spread, __values } from "tslib";
import Vue from 'vue';
import { isUndef } from '@/lib/utils';
var m = {
  namespaced: true,
  state: function state() {
    return {
      requesting: false,
      teamMap: {},
      teamRank: {},
      teamDistance: {},
      defaultSelectedTeamId: '0',
      userFinish: {},
      todayDistance: {},
      userDistance: {},
      thumbUpMap: {},
      teamThumbUp: {},
      // 个人点赞榜
      userThumbUp: {},
      invite: {},
      prize: {},

      /** 所有人的距离排行榜 */
      userTotalDistanceRank: {
        current: null,
        list: []
      },

      /** 个人坚持排行榜 */
      totalDays: {
        user: null,
        list: [],
        requesting: false,
        loaded: false
      },

      /** 个人里程排行榜 */
      totalDistance: {
        user: null,
        list: [],
        requesting: false,
        loaded: false
      },
      rankBannerMap: {},
      platformTotalDaysRank: {
        list: [],
        loaded: false,
        requesting: false,
        user: null
      },
      platformReferrerRank: {
        list: [],
        loaded: false,
        requesting: false,
        user: null
      },
      platformTermRank: {
        list: [],
        loaded: false,
        requesting: false,
        user: null
      },
      platformRankItem: {}
    };
  },
  mutations: {
    setRequesting: function setRequesting(state, requesting) {
      state.requesting = requesting;
    },
    setUserFinishRequesting: function setUserFinishRequesting(state, _a) {
      var teamId = _a.teamId,
          requesting = _a.requesting;
      Vue.set(state.userFinish[teamId], 'requesting', requesting);
    },
    setUserDistanceRequesting: function setUserDistanceRequesting(state, _a) {
      var teamId = _a.teamId,
          requesting = _a.requesting;
      Vue.set(state.userDistance[teamId], 'requesting', requesting);
    },
    setTodayDistanceRequesting: function setTodayDistanceRequesting(state, _a) {
      var teamId = _a.teamId,
          requesting = _a.requesting;
      Vue.set(state.todayDistance[teamId], 'requesting', requesting);
    },

    /** 初始化 */
    initTeamRank: function initTeamRank(state, key) {
      Vue.set(state.teamRank, key, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 战队完赛率请求中 */
    setTeamRankReq: function setTeamRankReq(state, _a) {
      var key = _a.key,
          bol = _a.bol;
      state.teamRank[key].requesting = bol;
    },

    /**
     * 记录战队完赛率数据
     * @param {} list
     */
    concatTeamRank: function concatTeamRank(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.teamRank[key].list = state.teamRank[key].list.concat(list);
    },

    /**
     * 记录战队完赛率个人数据
     * @param {} user 用户数据
     */
    setTeamRankUser: function setTeamRankUser(state, _a) {
      var key = _a.key,
          user = _a.user;
      state.teamRank[key].user = user;
    },

    /**
     * 记录战队完赛率是否加载
     */
    setTeamRankLoaded: function setTeamRankLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.teamRank[key].loaded = loaded;
    },

    /** 初始化 */
    initTeamDistance: function initTeamDistance(state, key) {
      Vue.set(state.teamDistance, key, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 战队完赛率请求中 */
    setTeamDistanceReq: function setTeamDistanceReq(state, _a) {
      var key = _a.key,
          bol = _a.bol;
      state.teamDistance[key].requesting = bol;
    },

    /**
     * 记录战队完赛率数据
     * @param {} list
     */
    concatTeamDistance: function concatTeamDistance(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.teamDistance[key].list = state.teamDistance[key].list.concat(list);
    },

    /**
     * 记录战队完赛率个人数据
     * @param {} user 用户数据
     */
    setTeamDistanceUser: function setTeamDistanceUser(state, _a) {
      var key = _a.key,
          user = _a.user;
      state.teamDistance[key].user = user;
    },

    /**
     * 记录战队完赛率是否加载
     */
    setTeamDistanceLoaded: function setTeamDistanceLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.teamDistance[key].loaded = loaded;
    },

    /**
     * 个人完赛排行
     *
     * @param {} teamId 班级id
     * @param {} data 排行数据
     *  - user 用户数据
     *  - list 排行数据
     */
    setUserFinish: function setUserFinish(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          data = _a.data,
          loaded = _a.loaded;
      var length = state.userFinish[teamId] ? state.userFinish[teamId].list.length : 0; // 处理点赞数据

      data.list.forEach(function (item, index) {
        var key = activityId + '_' + item.id;
        item.id = key;
        item.rank = length + index + 1;
        Vue.set(state.thumbUpMap, key, {
          userId: key,
          count: item.thumb_up_count,
          thumbUp: item.has_thumb_up
        });
      });
      var tempList = data.list;
      var tempUser = data.current;

      if (state.userFinish[teamId]) {
        tempList = state.userFinish[teamId].list.concat(tempList);
        tempUser = tempUser ? tempUser : state.userFinish[teamId].user;
      }

      Vue.set(state.userFinish, teamId, {
        requesting: false,
        user: tempUser,
        list: tempList,
        loaded: loaded
      });
    },

    /**
     * 记录用户距离
     */
    setUserDistance: function setUserDistance(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          data = _a.data,
          loaded = _a.loaded;
      var length = state.userDistance[teamId] ? state.userDistance[teamId].list.length : 0;
      data.list.forEach(function (item, index) {
        var key = activityId + '_' + item.id;
        item.id = key;
        item.rank = length + index + 1;
        Vue.set(state.thumbUpMap, key, {
          userId: key,
          count: item.thumb_up_count,
          thumbUp: item.has_thumb_up
        });
      });
      var tempList = data.list;
      var tempUser = data.current;

      if (state.userDistance[teamId]) {
        tempList = state.userDistance[teamId].list.concat(tempList);
        tempUser = tempUser ? tempUser : state.userDistance[teamId].user;
      }

      Vue.set(state.userDistance, teamId, {
        requesting: false,
        user: tempUser,
        list: tempList,
        loaded: loaded
      });
    },

    /**
     * 今日打卡
     */
    setTodayDistance: function setTodayDistance(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          data = _a.data,
          loaded = _a.loaded;
      var length = state.todayDistance[teamId] ? state.todayDistance[teamId].list.length : 0;
      data.list.forEach(function (item, index) {
        var key = activityId + '_' + item.id;
        item.id = key;
        item.rank = length + index + 1;
        Vue.set(state.thumbUpMap, key, {
          userId: key,
          count: item.thumb_up_count,
          thumbUp: item.has_thumb_up
        });
      });
      var tempList = data.list;
      var tempUser = data.current;

      if (state.todayDistance[teamId]) {
        tempList = state.todayDistance[teamId].list.concat(tempList);
        tempUser = tempUser ? tempUser : state.todayDistance[teamId].user;
      }

      Vue.set(state.todayDistance, teamId, {
        requesting: false,
        user: tempUser,
        list: tempList,
        loaded: loaded
      });
    },

    /**
     * 记录点赞
     *
     * @param {} userId 用户id
     * @param {} count 点赞数量
     * @param {} thumbUp 是否点赞
     */
    updateThumbUp: function updateThumbUp(state, _a) {
      var userId = _a.userId,
          count = _a.count,
          thumbUp = _a.thumbUp;
      Vue.set(state.thumbUpMap, userId, {
        userId: userId,
        count: count,
        thumbUp: thumbUp
      });
    },

    /** 初始化战队点赞数据 */
    initTeamThumbUp: function initTeamThumbUp(state, activityId) {
      Vue.set(state.teamThumbUp, activityId, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 战队点赞数据请求中 */
    setTeamThumbUpReq: function setTeamThumbUpReq(state, _a) {
      var activityId = _a.activityId,
          bol = _a.bol;
      state.teamThumbUp[activityId].requesting = bol;
    },

    /**
     * 记录战队点赞数据
     * @param {} list
     */
    concatTeamThumbUp: function concatTeamThumbUp(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      state.teamThumbUp[activityId].list = state.teamThumbUp[activityId].list.concat(list);
    },

    /**
     * 记录战队点赞个人数据
     * @param {} user 战队数据
     */
    setTeamThumbUpUser: function setTeamThumbUpUser(state, _a) {
      var activityId = _a.activityId,
          user = _a.user;
      state.teamThumbUp[activityId].user = user;
    },

    /**
     * 记录用户点赞是否加载
     */
    setTeamThumbUpLoaded: function setTeamThumbUpLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.teamThumbUp[activityId].loaded = loaded;
    },

    /** 初始化用户点赞数据 */
    initUserThumbUp: function initUserThumbUp(state, activityId) {
      Vue.set(state.userThumbUp, activityId, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 用户点赞请求中 */
    setUserThumbUpReq: function setUserThumbUpReq(state, _a) {
      var activityId = _a.activityId,
          bol = _a.bol;
      state.userThumbUp[activityId].requesting = bol;
    },

    /**
     * 记录用户点赞数据
     * @param {} list
     */
    concatUserThumbUp: function concatUserThumbUp(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      var dealList = list.filter(function (item) {
        return item.thumb_up_count !== 0;
      });
      state.userThumbUp[activityId].list = state.userThumbUp[activityId].list.concat(dealList);
    },

    /**
     * 记录用户点赞个人数据
     * @param {} user 用户数据
     */
    setUserThumbUpUser: function setUserThumbUpUser(state, _a) {
      var activityId = _a.activityId,
          user = _a.user;
      state.userThumbUp[activityId].user = user;
    },

    /**
     * 记录用户点赞是否加载
     */
    setUserThumbUpLoaded: function setUserThumbUpLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.userThumbUp[activityId].loaded = loaded;
    },

    /** 邀请人数排行是否加载完成 */
    setInvitePrizeLoaded: function setInvitePrizeLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.prize[activityId].loaded = loaded;
    },

    /** 邀请人数排行是否处于加载中 */
    setInvitePrizeReq: function setInvitePrizeReq(state, _a) {
      var activityId = _a.activityId,
          req = _a.req;
      state.prize[activityId].requesting = req;
    },

    /** 邀请人数排行 */
    concatInvitePrize: function concatInvitePrize(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      state.prize[activityId].list = state.prize[activityId].list.concat(list);
    },

    /** 初始化邀请人数排行 */
    initInvitePrize: function initInvitePrize(state, activityId) {
      Vue.set(state.prize, activityId, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 邀请人数排行是否加载完成 */
    setInviteLoaded: function setInviteLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.invite[activityId].loaded = loaded;
    },

    /** 邀请人数排行是否处于加载中 */
    setInviteReq: function setInviteReq(state, _a) {
      var activityId = _a.activityId,
          req = _a.req;
      state.invite[activityId].requesting = req;
    },

    /** 邀请人数排行 */
    concatInvite: function concatInvite(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      state.invite[activityId].list = state.invite[activityId].list.concat(list);
    },

    /** 初始化邀请人数排行 */
    initInvite: function initInvite(state, activityId) {
      Vue.set(state.invite, activityId, {
        list: [],
        user: null,
        loaded: false,
        requesting: false
      });
    },

    /** 记录邀请人数个人数据 */
    setInviteCurrent: function setInviteCurrent(state, _a) {
      var activityId = _a.activityId,
          current = _a.current;
      state.invite[activityId].user = current;
    },

    /**
     * 记录所有人的距离排行榜
     */
    setUserTotalDistanceRank: function setUserTotalDistanceRank(state, data) {
      state.userTotalDistanceRank = data;
      data.list.forEach(function (item) {
        Vue.set(state.thumbUpMap, String(item.id), {
          userId: item.id,
          count: item.thumb_up_count,
          thumbUp: item.has_thumb_up
        });
      });
    },

    /** 个人坚持排行榜 */
    setTotalDaysRequesting: function setTotalDaysRequesting(state, requesting) {
      state.totalDays.requesting = requesting;
    },
    concatTotalDaysList: function concatTotalDaysList(state, data) {
      state.totalDays.list = state.totalDays.list.concat(data.list);
      state.totalDays.user = data.current;
    },
    setTotalDaysLoaded: function setTotalDaysLoaded(state, loaded) {
      state.totalDays.loaded = loaded;
    },
    setRankBannerMap: function setRankBannerMap(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      Vue.set(state.rankBannerMap, activityId, list);
    },

    /** 个人里程排行榜 */
    setTotalDistanceRequesting: function setTotalDistanceRequesting(state, requesting) {
      state.totalDistance.requesting = requesting;
    },
    concatTotalDistanceList: function concatTotalDistanceList(state, data) {
      state.totalDistance.list = state.totalDistance.list.concat(data.list);
      state.totalDistance.user = data.current;
    },
    setTotalDistanceLoaded: function setTotalDistanceLoaded(state, loaded) {
      state.totalDistance.loaded = loaded;
    },

    /**
     * 平台坚持天数排行榜
     */
    concatPlatformTotalDaysRank: function concatPlatformTotalDaysRank(state, list) {
      var e_1, _a, _b;

      var ids = [];

      try {
        for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
          var item = list_1_1.value;
          var id = 'total_days_' + item.id;
          ids.push(id);

          if (!state.platformRankItem[id]) {
            Vue.set(state.platformRankItem, id, item);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (list_1_1 && !list_1_1.done && (_a = list_1["return"])) _a.call(list_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      (_b = state.platformTotalDaysRank.list).push.apply(_b, __spread(ids));
    },
    setPlatformTotalDaysRankLoaded: function setPlatformTotalDaysRankLoaded(state, loaded) {
      state.platformTotalDaysRank.loaded = loaded;
    },
    setPlatformTotalDaysRankReq: function setPlatformTotalDaysRankReq(state, req) {
      state.platformTotalDaysRank.requesting = req;
    },
    setPlatformTotalDaysRankUser: function setPlatformTotalDaysRankUser(state, user) {
      var id = 'total_days_' + user.id;
      Vue.set(state.platformRankItem, id, user);
      state.platformTotalDaysRank.user = id;
    },

    /**
     * 平台影响排行榜
     */
    concatPlatformReferrerRank: function concatPlatformReferrerRank(state, list) {
      var e_2, _a, _b;

      var ids = [];

      try {
        for (var list_2 = __values(list), list_2_1 = list_2.next(); !list_2_1.done; list_2_1 = list_2.next()) {
          var item = list_2_1.value;
          var id = 'referrer_' + item.id;
          ids.push(id);

          if (!state.platformRankItem[id]) {
            Vue.set(state.platformRankItem, id, item);
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (list_2_1 && !list_2_1.done && (_a = list_2["return"])) _a.call(list_2);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      (_b = state.platformReferrerRank.list).push.apply(_b, __spread(ids));
    },
    setPlatformReferrerRankLoaded: function setPlatformReferrerRankLoaded(state, loaded) {
      state.platformReferrerRank.loaded = loaded;
    },
    setPlatformReferrerRankReq: function setPlatformReferrerRankReq(state, req) {
      state.platformReferrerRank.requesting = req;
    },
    setPlatformReferrerRankUser: function setPlatformReferrerRankUser(state, user) {
      var id = 'referrer_' + user.id;
      Vue.set(state.platformRankItem, id, user);
      state.platformReferrerRank.user = id;
    },

    /**
     * 平台届数榜
     */
    concatPlatformTermRank: function concatPlatformTermRank(state, list) {
      var e_3, _a, _b;

      var ids = [];

      try {
        for (var list_3 = __values(list), list_3_1 = list_3.next(); !list_3_1.done; list_3_1 = list_3.next()) {
          var item = list_3_1.value;
          var id = 'term_' + item.id;
          ids.push(id);

          if (!state.platformRankItem[id]) {
            Vue.set(state.platformRankItem, id, item);
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (list_3_1 && !list_3_1.done && (_a = list_3["return"])) _a.call(list_3);
        } finally {
          if (e_3) throw e_3.error;
        }
      }

      (_b = state.platformTermRank.list).push.apply(_b, __spread(ids));
    },
    setPlatformTermRankLoaded: function setPlatformTermRankLoaded(state, loaded) {
      state.platformTermRank.loaded = loaded;
    },
    setPlatformTermRankReq: function setPlatformTermRankReq(state, req) {
      state.platformTermRank.requesting = req;
    },
    setPlatformTermRankUser: function setPlatformTermRankUser(state, user) {
      var id = 'term_' + user.id;
      Vue.set(state.platformRankItem, id, user);
      state.platformTermRank.user = id;
    },

    /**
     * 点赞
     */
    setPlatformThumbUp: function setPlatformThumbUp(state, _a) {
      var id = _a.id,
          hasThumbUp = _a.hasThumbUp;
      var item = state.platformRankItem[id];

      if (item) {
        item.has_thumb_up = hasThumbUp;
        item.thumb_up_count += hasThumbUp ? 1 : -1;
      }
    }
  },
  actions: {
    /**
     * 获取个人完赛率榜单
     */
    getUserFinishRank: function getUserFinishRank(_a, _b) {
      var rootState = _a.rootState,
          state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata, data, userId, key;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!state.userFinish[teamId]) {
                Vue.set(state.userFinish, teamId, {
                  list: [],
                  user: null,
                  loaded: false,
                  requesting: false
                });
              }

              temp = state.userFinish[teamId];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setUserFinishRequesting', {
                teamId: teamId,
                requesting: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_finish_rate_rank', {
                params: {
                  id: activityId,
                  team_id: teamId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setUserFinish', {
                  activityId: activityId,
                  teamId: teamId,
                  data: data,
                  loaded: data.list.length < count
                });

                if (!isUndef(data.current)) {
                  userId = rootState.user.basicInfo ? rootState.user.basicInfo.id : '';
                  key = activityId + '_' + userId;
                  Vue.set(state.thumbUpMap, key, {
                    userId: key,
                    count: data.current.thumb_up_count,
                    thumbUp: data.current.has_thumb_up
                  });
                }
              }

              commit('setUserFinishRequesting', {
                teamId: teamId,
                requesting: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取个人距离排行榜
     */
    getUserDistance: function getUserDistance(_a, _b) {
      var rootState = _a.rootState,
          state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata, data, userId, key;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!state.userDistance[teamId]) {
                Vue.set(state.userDistance, teamId, {
                  requesting: false,
                  loaded: false,
                  list: [],
                  user: null
                });
              }

              temp = state.userDistance[teamId];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setUserDistanceRequesting', {
                teamId: teamId,
                requesting: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_team_total_distance_rank', {
                params: {
                  id: activityId,
                  team_id: teamId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setUserDistance', {
                  activityId: activityId,
                  teamId: teamId,
                  data: data,
                  loaded: data.list.length < count
                });

                if (!isUndef(data.current)) {
                  userId = rootState.user.basicInfo ? rootState.user.basicInfo.id : '';
                  key = activityId + '_' + userId;
                  Vue.set(state.thumbUpMap, key, {
                    userId: key,
                    count: data.current.thumb_up_count,
                    thumbUp: data.current.has_thumb_up
                  });
                }
              }

              commit('setUserDistanceRequesting', {
                teamId: teamId,
                requesting: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 今日距离排行榜
     */
    getTodayDistance: function getTodayDistance(_a, _b) {
      var rootState = _a.rootState,
          state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata, data, userId, key;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!state.todayDistance[teamId]) {
                Vue.set(state.todayDistance, teamId, {
                  requesting: false,
                  loaded: false,
                  list: [],
                  user: null
                });
              }

              temp = state.todayDistance[teamId];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTodayDistanceRequesting', {
                teamId: teamId,
                requesting: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/today_distance_rank', {
                params: {
                  id: activityId,
                  team_id: teamId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setTodayDistance', {
                  activityId: activityId,
                  teamId: teamId,
                  data: data,
                  loaded: data.list.length < count
                });

                if (!isUndef(data.current)) {
                  userId = rootState.user.basicInfo ? rootState.user.basicInfo.id : '';
                  key = activityId + '_' + userId;
                  Vue.set(state.thumbUpMap, key, {
                    userId: key,
                    count: data.current.thumb_up_count,
                    thumbUp: data.current.has_thumb_up
                  });
                }
              }

              commit('setTodayDistanceRequesting', {
                teamId: teamId,
                requesting: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队完赛排行榜单
     */
    getTeamRank: function getTeamRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          levelId = _b.levelId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var key, temp, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              key = activityId + '_' + levelId;

              if (!state.teamRank[key]) {
                commit('initTeamRank', key);
              }

              temp = state.teamRank[key];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTeamRankReq', {
                key: key,
                bol: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_finish_rate_rank', {
                params: {
                  id: activityId,
                  level_id: levelId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatTeamRank', {
                  key: key,
                  list: rdata.data.list
                });

                if (rdata.data.current) {
                  commit('setTeamRankUser', {
                    key: key,
                    user: rdata.data.current
                  });
                }

                if (rdata.data.list.length < count) {
                  commit('setTeamRankLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setTeamRankReq', {
                key: key,
                bol: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队里程排行榜单
     */
    getTeamDistance: function getTeamDistance(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          levelId = _b.levelId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var key, temp, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              key = activityId + '_' + levelId;

              if (!state.teamDistance[key]) {
                commit('initTeamDistance', key);
              }

              temp = state.teamDistance[key];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTeamDistanceReq', {
                key: key,
                bol: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_level_total_distance_rank', {
                params: {
                  id: activityId,
                  level_id: levelId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatTeamDistance', {
                  key: key,
                  list: rdata.data.list
                });

                if (rdata.data.current) {
                  commit('setTeamDistanceUser', {
                    key: key,
                    user: rdata.data.current
                  });
                }

                if (rdata.data.list.length < count) {
                  commit('setTeamDistanceLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setTeamDistanceReq', {
                key: key,
                bol: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 战队点赞榜
     */
    getTeamThumbUpRank: function getTeamThumbUpRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!state.teamThumbUp[activityId]) {
                commit('initTeamThumbUp', activityId);
              }

              temp = state.teamThumbUp[activityId];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTeamThumbUpReq', {
                activityId: activityId,
                bol: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_thumb_up_rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatTeamThumbUp', {
                  activityId: activityId,
                  list: rdata.data.list
                });

                if (rdata.data.current) {
                  commit('setTeamThumbUpUser', {
                    activityId: activityId,
                    user: rdata.data.current
                  });
                }

                if (rdata.data.list.length < count) {
                  commit('setTeamThumbUpLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }
              }

              commit('setTeamThumbUpReq', {
                activityId: activityId,
                bol: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 用户点赞榜
     * @param {} offset
     * @param {} count
     */
    getUserThumbUpRank: function getUserThumbUpRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (!state.userThumbUp[activityId]) {
                commit('initUserThumbUp', activityId);
              }

              temp = state.userThumbUp[activityId];

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setUserThumbUpReq', {
                activityId: activityId,
                bol: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_thumb_up_rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatUserThumbUp', {
                  activityId: activityId,
                  list: rdata.data.list
                });

                if (rdata.data.current) {
                  commit('setUserThumbUpUser', {
                    activityId: activityId,
                    user: rdata.data.current
                  });
                }

                if (rdata.data.list.length < count) {
                  commit('setUserThumbUpLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }
              }

              commit('setUserThumbUpReq', {
                activityId: activityId,
                bol: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 执行点赞，同时也更新了store中的原本数据
     *
     * @param {} userId 用户id
     *
     * @return {} void
     */
    thumbUp: function thumbUp(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var map, rdata, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              map = state.thumbUpMap; // 在还没有点赞的情况下才允许发送请求

              if (!map[userId]) {
                // 这里应该发生了错误
                return [2
                /*return*/
                , false];
              }

              if (!map[userId].thumbUp) return [3
              /*break*/
              , 2];
              commit('updateThumbUp', {
                userId: userId,
                count: map[userId].count - 1,
                thumbUp: false
              });
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/cancel_thumb_up', {
                activity_id: activityId,
                user_id: userId.split('_')[1]
              })];

            case 1:
              rdata = _c.sent();
              return [2
              /*return*/
              , rdata];

            case 2:
              // 先更新数据
              commit('updateThumbUp', {
                userId: userId,
                count: map[userId].count + 1,
                thumbUp: true
              });
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/create_thumb_up', {
                activity_id: activityId,
                user_id: userId.split('_')[1]
              })];

            case 3:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status !== 0) {
                _Toast(rdata.message);

                return [2
                /*return*/
                ];
              }

              return [2
              /*return*/
              , response];
          }
        });
      });
    },

    /**
     * 获取个人距离总榜 不限制战队
     * @param activityId 活动id
     */
    getUserTotalDistanceRank: function getUserTotalDistanceRank(_a, activityId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              commit('setRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_total_distance_rank', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setUserTotalDistanceRank', rdata.data);
              }

              commit('setRequesting', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得邀请榜单
     */
    getInviteRank: function getInviteRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var invite, list, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.invite[activityId]) {
                commit('initInvite', activityId);
              }

              invite = state.invite[activityId];

              if (invite.requesting || invite.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                invite.loaded = false;
                invite.list = [];
              }

              list = invite.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setInviteReq', {
                activityId: activityId,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_referrer_rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatInvite', {
                  activityId: activityId,
                  list: rdata.data.list
                });
                commit('setInviteCurrent', {
                  activityId: activityId,
                  current: rdata.data.current
                });

                if (rdata.data.list.length < count) {
                  commit('setInviteLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }
              }

              commit('setInviteReq', {
                activityId: activityId,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得邀请奖励榜单
     */
    getInvitePrizeRank: function getInvitePrizeRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var prize, list, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.prize[activityId]) {
                commit('initInvitePrize', activityId);
              }

              prize = state.prize[activityId];

              if (prize.requesting || prize.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                prize.loaded = false;
                prize.list = [];
              }

              list = prize.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setInvitePrizeReq', {
                activityId: activityId,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/invite_prize', {
                params: {
                  id: activityId,
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatInvitePrize', {
                  activityId: activityId,
                  list: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setInvitePrizeLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }
              }

              commit('setInvitePrizeReq', {
                activityId: activityId,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取个人坚持排行榜
     */
    getTotalDaysRank: function getTotalDaysRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              temp = state.totalDays;

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTotalDaysRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_total_days_rank', {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatTotalDaysList', data);

                if (rdata.data.list.length < count) {
                  commit('setTotalDaysLoaded', true);
                }
              }

              commit('setTotalDaysRequesting', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取个人里程排行榜
     */
    getTotalDistanceRank: function getTotalDistanceRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, list, end, response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              temp = state.totalDistance;

              if (temp.requesting || temp.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                temp.loaded = false;
                temp.list = [];
              }

              list = temp.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setTotalDistanceRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_activity_total_distance_rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatTotalDistanceList', data);

                if (rdata.data.list.length < count) {
                  commit('setTotalDistanceLoaded', true);
                }
              }

              commit('setTotalDistanceRequesting', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取排行顶部banner
     */
    getRankBanner: function getRankBanner(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var temp, response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              temp = state.rankBannerMap[activityId];

              if (temp && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/rank_banner', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setRankBannerMap', {
                  activityId: activityId,
                  list: data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取坚持天数排行榜
     */
    getPlatformTotalDaysRank: function getPlatformTotalDaysRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, list, end, response, rdata, list_4, user;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.platformTotalDaysRank;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              list = wrap.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setPlatformTotalDaysRankReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/total_days_rank', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list_4 = rdata.data.list;
                user = rdata.data.current;
                commit('concatPlatformTotalDaysRank', list_4);

                if (list_4.length < count) {
                  commit('setPlatformTotalDaysRankLoaded', true);
                }

                if (user) {
                  commit('setPlatformTotalDaysRankUser', user);
                }
              }

              commit('setPlatformTotalDaysRankReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取推荐排行榜
     */
    getPlatformReferrerRank: function getPlatformReferrerRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, list, end, response, rdata, list_5, user;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.platformReferrerRank;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              list = wrap.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setPlatformReferrerRankReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/referrer_rank', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list_5 = rdata.data.list;
                user = rdata.data.current;
                commit('concatPlatformReferrerRank', list_5);

                if (list_5.length < count) {
                  commit('setPlatformReferrerRankLoaded', true);
                }

                if (user) {
                  commit('setPlatformReferrerRankUser', user);
                }
              }

              commit('setPlatformReferrerRankReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取坚持届数榜单
     */
    getPlatformTermRank: function getPlatformTermRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, list, end, response, rdata, list_6, user;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              wrap = state.platformTermRank;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              list = wrap.list;
              end = offset + count;

              if (end <= list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < list.length) {
                offset = list.length;
                count = end - offset;
              }

              commit('setPlatformTermRankReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/finish_count_rank', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list_6 = rdata.data.list;
                user = rdata.data.current;
                commit('concatPlatformTermRank', list_6);

                if (list_6.length < count) {
                  commit('setPlatformTermRankLoaded', true);
                }

                if (user) {
                  commit('setPlatformTermRankUser', user);
                }
              }

              commit('setPlatformTermRankReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 点赞/取消点赞
     */
    platformThumbUp: function platformThumbUp(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var id = _b.id,
          type = _b.type;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, item;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/user/thumb_up', {
                id: id
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                item = state.platformRankItem[type + '_' + id];

                if (item) {
                  commit('setPlatformThumbUp', {
                    id: type + '_' + id,
                    hasThumbUp: !item.has_thumb_up
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;